import { render, staticRenderFns } from "./TermsBahasaComponen.vue?vue&type=template&id=cd9b09a0&scoped=true"
import script from "./TermsBahasaComponen.vue?vue&type=script&lang=js"
export * from "./TermsBahasaComponen.vue?vue&type=script&lang=js"
import style0 from "./TermsBahasaComponen.vue?vue&type=style&index=0&id=cd9b09a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9b09a0",
  null
  
)

export default component.exports